// extracted by mini-css-extract-plugin
export default {"logoAssetCard":"logoCatalog_logoAssetCard__hGYqs","category__card--img":"logoCatalog_category__card--img__6KEan","category__card--body":"logoCatalog_category__card--body__wM6JD"};